import React from 'react'

const LOCALE_LABELS = {
  de: 'Deutsch',
  el: 'Ελληνικά',
  en: 'English',
  fr: 'Français'
}

export default function LanguagePicker({ className = '' }) {
  const availableLocales = (Cas.availableLocales || [Cas.locale]).map(locale => (
    typeof locale === 'string' ? { key: locale } : locale
  ))

  function buildLocalePath(locale) {
    const availableLocaleKeys = availableLocales.map(availableLocale => availableLocale.key)
    const pathParts = window.location.pathname.split('/')

    if (availableLocaleKeys.includes(pathParts[1])) {
      pathParts[1] = locale
    } else {
      pathParts.splice(1, 0, locale)
    }

    return `${pathParts.join('/')}${window.location.search}${window.location.hash}`
  }

  function handleLocaleChange(event) {
    const nextLocale = event.target.value

    if (nextLocale !== Cas.locale) {
      window.location.href = buildLocalePath(nextLocale)
    }
  }

  if (availableLocales.length < 2) {
    return null
  }

  return (
    <div className={`language-picker ${className}`}>
      <i className='fa-light fa-globe'></i>
      <select value={Cas.locale} onChange={handleLocaleChange} aria-label='Language'>
        { availableLocales.map(locale => (
          <option key={locale.key} value={locale.key}>
            {locale.label || LOCALE_LABELS[locale.key] || locale.key.toUpperCase()}
          </option>
        )) }
      </select>
      <i className='fa-light fa-chevron-down'></i>
    </div>
  )
}
